import { defaultProfileImage } from "../../../utils/constants";
import { ExperienceGuestInfo, GuestStatus } from "../models/GuestStatus"

interface Props {
  user:ExperienceGuestInfo,
  status?:number,
}

export const GuestCard: React.FC<Props> = ({ user, status }) => {

  const getLabelDate = () => {
    switch (status) {
      case GuestStatus.CONFIRMED:
        return 'Confirmed at ';
        break;
      case GuestStatus.PENDING_PAYMENT:
        return 'Pending payment at ';
        break;
      case GuestStatus.PENDING_INVITATION:
        return 'Pending invitation at ';
        break;
      case GuestStatus.DECLINED:
        return 'Declined at ';
        break;
      default:
        return '';
        break;
    }
  }

  return (
    <div className="guest-card">
      <div className="guest-card__left">
        <div className="card-profile-avatar">
          <img src={user?.profilePicture || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt="Guest" />
          <span>{user?.fullName} {user?.firstName} {user?.lastName}</span>
        </div>

        <div className="guest-card__date">
          {getLabelDate() + (user?.updatedAt)}
        </div>
      </div>

      <div className="guest-card__right">
        <div className="guest-card__count">{user?.tickets || 1} Guest</div>

        <div className="w-100 d-flex flex-row">
          <div className="guest-card__breakdown">
            <span>Adult: </span>
            <span>{user?.tickets || 1}</span>
          </div>
          <div className="guest-card__breakdown">
            <span>7-12 Years Old:</span>
            <span> 0</span>
          </div>
          <div className="guest-card__breakdown">
            <span>12+ Years Old</span>
            <span>0</span>
          </div>
        </div>
      </div>
    </div>
  )
}